import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'
import { Props } from './saveBomItemMaterialCostPrice'

export const setPurchasingPartAndPricePerItem = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'bomItem/setPurchasingPriceAndMaterialCostPrice',
  async (args: Props, thunkAPI) => {
    const { partyId: organizationId, projectId } = getContext(thunkAPI.getState)

    const controller = new BomItemController(organizationId, projectId)

    try {
      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: args.bomItemId,
          financial: {
            salesPricePerItem: args.materialCostPrice,
          },
          isPurchasingBomItem: true,
          workingSteps: [
            {
              primaryWorkingStep: WorkingStepType.Purchasing,
              secondaryWorkingStep: WorkingStepType.Purchasing,
            },
          ],
        })
      )

      await controller.SetAsPurchasingItem([args.bomItemId])
      await controller.SetMaterialCostPrice(
        args.bomItemId,
        args.materialCostPrice,
        args.priceScope
      )
    } catch (error) {
      ShowException('project', error)
      await thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw error
    }
  }
)
